/**
 * globals.js
 *
 * This file contains constants for the truck app frontend.
 */

export const MGE_CONTAINER_NUM = 569
export const MGE_LOCATION_ID = 515
export const NO_CONTAINER_NAME = 'No Container'
